<script lang="ts">
  import Layout from "$app/Layouts/Admin.svelte"
  import { bullets } from "$app/utils"
  import { Trash, Pen } from "lucide-svelte"
  import Modal from "$app/components/Modal.svelte"
  import { formatDate, toast, xhr, wait, getVideoThumb } from "$app/utils"
  import Form from "./Form.svelte"
  import { appStore } from "$app/store.svelte"

  let props = $props()
  let videos: VideoType[] = $state(props.videos)
  let categories: string[] = props.categories
  let statuses: string[] = props.statuses

  let currentVideo: VideoType | {} = $state({}) as VideoType
  let status = $state("")
  let openModal = $state(false)

  appStore.categories = categories

  function editVideo(video: VideoType): void {
    currentVideo = video
    status = "edit"
    openModal = true
  }

  async function deleteVideo(video: VideoType): Promise<void> {
    video._selected = true
    videos = videos
    await wait(50)
    if (!confirm("Are you sure you want to delete the selected video?")) {
      video._selected = false
      videos = videos
      return
    }

    try {
      await xhr.delete(`/admin/videos/${video.id}`)
      videos = videos.filter((b) => b.id !== video.id)
      toast("Video deleted successfully", "success")
    } catch (e) {
      toast("Error deleting video", "error")
    } finally {
      video._selected = false
      videos = videos
    }
  }

  let searchText = ""
  let searchStatus = ""
</script>

<Layout {...props}>
  <span slot="title">Video</span>

  <div class="flex mb-4">
    <div class="flex gap-2 py-4">
      <!--
      <input
        type="text"
        class="input-admin w-80"
        placeholder="Title or author"
        bind:value={searchText}
      />
      <select bind:value={searchStatus} class="input-admin">
        <option value="" />
        {#each statuses as s}
          <option value={s}>{s}</option>
        {/each}
      </select>
      <button
        class="btn primary"
        on:click={() => search(1)}
        disabled={searching}
      >
        Search
      </button>
      -->
    </div>

    <div class="w-full text-right">
      <button
        class="btn primary font-bold text-lg"
        onclick={() => {
          currentVideo = {}
          status = "new"
          openModal = true
        }}
      >
        + New Video
      </button>
    </div>
  </div>

  <div class="bg-white rounded-lg">
    <ul>
      {#each videos as video}
        <li
          class="flex gap-2 mb-4 border-b border-gray-600 pb-4 text-gray-700 px-2"
          class:bg-gray-600={video._selected}
        >
          <a href={video.url} target="_blank">
            <img src={video.thumbnail_url} width="300" alt={video.title} />
          </a>
          <div class="w-full py-2 px-4">
            <div class="font-semibold">
              {video.title}
            </div>
            <div>
              <div class="font-bold flex gap-1 items-center">
                <span
                  class:text-green-500={video.public}
                  class:text-red-500={!video.public}
                >
                  {video.public ? "Public" : "Private"}
                </span>
              </div>
              <span
                class="bg-indigo-400 px-2 text-core text-sm py-0.5 rounded-md"
              >
                {video.status}
              </span>
              {@html bullets(video.categories)}
            </div>
          </div>
          <div class="italic whitespace-nowrap py-2">
            {formatDate(video.created_at)}
          </div>
          <div class="flex gap-4 px-4">
            <button onclick={() => editVideo(video)}>
              <Pen />
            </button>
            <button onclick={() => deleteVideo(video)}>
              <Trash />
            </button>
          </div>
        </li>
      {/each}
    </ul>
  </div>
</Layout>

<Modal bind:open={openModal}>
  <Form
    {categories}
    {statuses}
    video={currentVideo}
    {status}
    oncreated={(video) => {
      videos = [video, ...videos]
      status = ""
    }}
    onupdated={(video) => {
      const idx = videos.findIndex((d) => d.id === video.id)
      videos[idx] = { ...videos[idx], ...video }
      status = ""
    }}
  />
</Modal>
